(() => {
  'use strict';

  const form = document.getElementById('GiftCardProductForm');
  if (!form) return;

  const toggle = form.querySelector('[data-gift-recipient-toggle]');
  const fields = form.querySelector('[data-gift-recipient-fields]');
  const email = form.querySelector('[data-gift-recipient-email]');
  const sendDate = form.querySelector('[data-gift-send-date]');
  const offset = form.querySelector('[data-gift-offset]');
  const message = form.querySelector('[data-gift-message]');
  const messageCount = form.querySelector('[data-gift-message-count]');
  const price = document.querySelector('[data-gift-card-price]');
  const radios = [...form.querySelectorAll('[data-gift-card-variant]')];

  const localDateString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const today = new Date();
  const maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 90);
  if (sendDate) {
    sendDate.min = localDateString(today);
    sendDate.max = localDateString(maxDate);
  }
  if (offset) offset.value = String(new Date().getTimezoneOffset());

  const syncRecipient = () => {
    if (!toggle || !fields) return;
    const enabled = toggle.checked;
    fields.hidden = !enabled;
    toggle.setAttribute('aria-expanded', String(enabled));
    fields.querySelectorAll('input, textarea, select').forEach((control) => {
      control.disabled = !enabled;
    });
    if (email) email.required = enabled;
    if (enabled && offset) offset.value = String(new Date().getTimezoneOffset());
  };

  const syncMessageCount = () => {
    if (message && messageCount) messageCount.textContent = `${message.value.length}/200`;
  };

  const syncPrice = (radio) => {
    if (!radio || !price) return;
    price.textContent = radio.dataset.price || price.textContent;
  };

  toggle?.addEventListener('change', syncRecipient);
  message?.addEventListener('input', syncMessageCount);
  radios.forEach((radio) => radio.addEventListener('change', () => syncPrice(radio)));

  syncRecipient();
  syncMessageCount();
  syncPrice(radios.find((radio) => radio.checked));
})();
